import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelTextarea from '../../../components/voxel/Forms/VoxelTextArea';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../graphql/projects/projectsApiService';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/pro-regular-svg-icons';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

interface FormState {
  negativeTerms: string;
}

export interface NegativeTermsFormProps {
  project: ProjectGq;
  setDirty: (dirty: boolean) => void;
  setSave: (saveFunction: () => Promise<unknown>) => void;
  reload: () => Promise<unknown>;
  disabled?: boolean;
}

const NegativeTermsForm: React.FC<NegativeTermsFormProps> = ({
  project,
  setDirty,
  setSave,
  reload,
  disabled,
}) => {
  const mutation = projectsApiService.mutations.projects.useUpdateProjectNegativeTerms();

  const formikProps = useFormik<FormState>({
    initialValues: {
      negativeTerms: project.negativeTermsSource ?? '',
    },
    enableReinitialize: true,
    onSubmit: (values, actions) =>
      mutation({
        id: project.id,
        negativeTerms: values.negativeTerms,
      })
        .catch((error) => console.error(error))
        .then(() => reload()),
  });

  useEffect(() => setSave(formikProps.submitForm), [formikProps.submitForm]);
  useEffect(() => {
    setDirty(formikProps.dirty);
    return () => setDirty(false);
  }, [formikProps.dirty]);

  return (
    <VoxelFormPanel
      disabled={disabled}
      title={<span>Negative terms</span>}
      subtitle={
        <span>
          Keywords containing these terms, as standalone words, will be automatically archived.
        </span>
      }
    >
      <VoxelFormPanelContent>
        <VoxelTextarea
          id="negativeTerms"
          placeholder={''}
          value={formikProps.values.negativeTerms}
          onChange={(event) => formikProps.setFieldValue('negativeTerms', event.target.value)}
          deleteValue={() => formikProps.setFieldValue('negativeTerms', '')}
          disabled={formikProps.isSubmitting}
          minRows={5}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formikProps.submitForm}
          disabled={
            formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty || disabled
          }
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default NegativeTermsForm;
